import axiosInstance from "./axiosInstance";

export const getUsersList = (params = {}) => {
  return axiosInstance.get("/users", { params });
};

export const importUsers = (rows) => {
  return axiosInstance.post("/user/import", { rows });
};

export const getUserData = (id) => {
  return axiosInstance.get(`access/${id}`);
};

export const updateUserLanguage = (params, id) => {
  return axiosInstance.post(`access/language/${id}`, params);
};

export const updateUserCorporation = (params, id) => {
  return axiosInstance.post(`access/corporation/${id}`, params);
};

export const updateUserFcmToken = (params) => {
  return axiosInstance.post(`access/fcmToken`, params);
};

export const updatePushDiagnostics = (params) => {
  return axiosInstance.post(`access/pushDiagnostics`, params);
};

export const sendPushTest = (userId) => {
  return axiosInstance.post(`access/${userId}/push-test`);
};

export const unlockUser = (userId) => {
  return axiosInstance.post(`access/${userId}/unlock`);
};

export const updateUserDisplayZoom = (params, id) => {
  return axiosInstance.post(`access/displayZoom/${id}`, params);
};

export const deleteUserFcmToken = (fcmToken) => {
  return axiosInstance.delete(`access/fcmToken`, { data: { fcmToken } });
};

export const sendReportingMail = (params) => {
  return axiosInstance.post(`mail/sendReportingMail`, params);
};

export const sendReviewReport = (params) => {
  return axiosInstance.post(`mail/sendReviewReport`, params);
};
